import React from 'react';
import { stats } from '../../data/content';
export function StatsBar() {
  return <section aria-label="Numeri del Percorso Clinico GLP-1" className="w-full border-y border-[#0E3B42]/10 bg-white px-5 py-8 sm:px-6 sm:py-10" data-id="element-224" data-mp="1j8ma64pvky1q">
      <dl className="mx-auto grid max-w-4xl grid-cols-2 gap-y-7 sm:grid-cols-4 sm:gap-y-0" data-id="element-225" data-mp="1o6nqwiztwla1">
        {stats.map((stat, index) => <div key={stat.label} className={`flex flex-col items-center px-2 text-center ${index % 2 === 1 ? 'border-l border-[#0E3B42]/10' : ''} ${index > 0 ? 'sm:border-l sm:border-[#0E3B42]/10' : ''}`} data-id="element-226" data-mp="1x0izk105stuf" data-mpi={index}>
            <dt className="sr-only" data-id="element-227" data-mp="26wdmh8bf1b30">{stat.label}</dt>
            <dd className="flex flex-col items-center" data-id="element-228" data-mp="2bxt9v712ftok">
              <span className="font-display text-3xl font-bold tracking-tight text-[#0E3B42] sm:text-4xl" data-id="element-229" data-mp="2bv70r2yj1648">
                {stat.value}
              </span>
              <span className="mt-1.5 max-w-[10rem] text-[11px] font-bold uppercase leading-snug tracking-[0.1em] text-[#4A6B70]" data-id="element-230" data-mp="hkbh95lt06mo">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}